import Call from '../Call.v3';

import qs from 'querystring';

const AdkClickDomainReplacementLog = {
    get: async (filters = {}) => Call(`adk/click_domain_replacement_log?${qs.stringify(filters)}`),
};

export default AdkClickDomainReplacementLog;



// WEBPACK FOOTER //
// ./src/services/API/components/AdkClickDomainReplacementLog.js